export default __webpack_public_path__ + "static/media/circled-checkmark.ecc46cc4.svg";